import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';

import { _ } from '/@/locale';
import { formatEnvironmentRange } from '/@/utils';
import styles from './styles.module.css';

@autobind
export default class HeadToHeadInfo extends Component {
    static propTypes = {
        crop: PropTypes.string.isRequired,
        head: PropTypes.shape({
            name: PropTypes.string.isRequired,
        }),
        environment: PropTypes.shape({
            min: PropTypes.number,
            max: PropTypes.number,
        }),
        zone: PropTypes.shape({
            name: PropTypes.object,
        }),
        showZone: PropTypes.bool,
    };

    static contextTypes = {
        units: PropTypes.object,
    };

    render() {
        return (
            <div className={styles.root}>
                {this.props.showZone && this.props.zone && (
                    <Fragment>
                        <div className={styles.label}>{_('Zona')}</div>
                        <div className={styles.value}>{_(this.props.zone.name)}</div>
                    </Fragment>
                )}
                {this.props.environment && (
                    <Fragment>
                        <div className={styles.label}>{_('Ambiente')}</div>
                        <div className={styles.value}>
                            {formatEnvironmentRange(this.props.environment, (value) =>
                                this.context.units.toYield(value, this.props.crop)
                            )}
                        </div>
                    </Fragment>
                )}
                {this.props.head && (
                    <Fragment>
                        <div className={styles.label}>{_('Head')}</div>
                        <div className={styles.value}>{this.props.head.name}</div>
                    </Fragment>
                )}
            </div>
        );
    }
}
